import Clipboard from 'clipboard'

export default {
  bind(el, binding, vnode, oldVnode) {
    new Clipboard(el)
  },
}
